var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilstonePolygon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7071 43.2929C22.3166 43.6834 21.6834 43.6834 21.2929 43.2929L0.707106 22.7071C0.31658 22.3166 0.31658 21.6834 0.707106 21.2929L21.2929 0.70711C21.6834 0.316584 22.3166 0.316584 22.7071 0.707109L43.2929 21.2929C43.6834 21.6834 43.6834 22.3166 43.2929 22.7071L22.7071 43.2929Z",
    fill: "#2B2B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilstonePolygon);
export default __webpack_public_path__ + "static/media/MilstonePolygon.89d59447.svg";
export { ForwardRef as ReactComponent };